import SearchVMBase from "../../../../Lib/Fs.SmartClient.Client/SearchVMBase";
import ConfigurationEditorVM from "./ConfigurationEditorVM";
import SortingCriteria from "../../../../Lib/Fs.Core.Data/SortingCriteria";
import PagingCriteria from "../../../../Lib/Fs.Core.Data/PagingCriteria";
import FsUtility from "../../../../Lib/Fs.SmartClient.Client/FsUtility";
import { DialogService } from 'aurelia-dialog';
import ConfigurationData from "../../Scripts/AppServiceContract/ConfigurationData";
import ConfigurationSearchParameter from "../../Scripts/AppServiceContract/ConfigurationSearchParameter";
import ConfigurationAppService from "../../Scripts/AppServiceContract/ConfigurationAppService";
import ConfigurationSearchCriteria from "../../Scripts/AppServiceContract/ConfigurationSearchCriteria";
import ConfigurationItemCategoryData from "../../Scripts/AppServiceContract/ConfigurationItemCategoryData";
import { useView, autoinject, Container } from 'aurelia-framework'
import { EventAggregator } from 'aurelia-event-aggregator';
import { PLATFORM } from 'aurelia-pal';

@autoinject
@useView(PLATFORM.moduleName("./ConfigurationSearchView.html"))
export default class ConfigurationSearchVM extends SearchVMBase<ConfigurationEditorVM>{
  public eventAggregator: EventAggregator;
  public changeLocaleSubscribe: any;
  public codePage: string;
  public notePage: string;
  public header: string;
  public note: string;
  public CategoryCode: string = null;
  ConfigurationCategoryList: ConfigurationItemCategoryData[];
  configurationCode: string;
  isStucture: boolean = false;
  public DialogService: DialogService;
  dialogService: DialogService;
  constructor(eventAggregator: EventAggregator = null) {
    super(ConfigurationEditorVM);
    var self = this;
    this.SearchDropdown();
    this.Search();
    this.IsSearchAfterSave = true;
    this.IsClearSelectionAfterSave = true;
    self.eventAggregator = eventAggregator;
    self.changeLocaleSubscribe = self.eventAggregator.subscribe('ChangeLocale', function (response) {
      self.Search();
      self.SearchDropdown();
    });
  }
  activate(params, route) {

    const self = this;

    if (typeof route !== "undefined") {

      this.codePage = route.settings.Header;
      this.notePage = route.settings.Note;
    }
  }

  SearchDropdown() {
    var service = this.container.get(ConfigurationAppService) as ConfigurationAppService;
    service.FindCategoryData()
      .done((result) => {
        this.ConfigurationCategoryList = result;
      }).fail((error) => {
        FsUtility.CommonErrorHandler(error);
      });
  }

  SearchItems(searchCallback: (result: ConfigurationData[]) => void, sortingCriteria: SortingCriteria, pagingCriteria: PagingCriteria) {
    var self = this;
    if (this.CategoryCode != null) {
      var searchParameter = new ConfigurationSearchParameter();
      searchParameter.SearchCriteria = this.SearchCriteria;
      searchParameter.SortingCriteria = this.SortingCriteria;
      searchParameter.PagingCriteria = this.PagingCriteria;
      var service = this.container.get(ConfigurationAppService) as ConfigurationAppService;
      service.Find(searchParameter)
        .done((result) => {
          searchCallback(result);
        }).fail((error) => {
          FsUtility.CommonErrorHandler(error);
        });
    }
  }

  CountItems(countCallback: (result: number) => void) {
    var self = this;
    var req = self.CreateCriteria();


    if (this.CategoryCode != null) {

      if (!this.CheckCriteriaEquals(req)) {
        this.SearchCriteria = req;
        var service = this.container.get(ConfigurationAppService) as ConfigurationAppService;
        service.Count(this.CreateCriteria())
          .done((result) => {
            countCallback(result)
          }).fail((error) => {
            FsUtility.CommonErrorHandler(error);
          });
      } else {
        countCallback(this.ItemCount);
      }
    }

  }

  SearchCriteria: ConfigurationSearchCriteria;

  CheckCriteriaEquals(searchCriteria: ConfigurationSearchCriteria) {
    if (this.SearchCriteria == null) return false;
    return JSON.stringify(this.SearchCriteria) == JSON.stringify(searchCriteria);
  }

  CreateCriteria(): ConfigurationSearchCriteria {
    var criteria = new ConfigurationSearchCriteria();
    criteria.CategoryCode = this.CategoryCode;
    return criteria;
  }

  SelectConfiguration(val) {
    this.CategoryCode = val
    this.Search()
  };
}
